import { render } from "./TrainingReflection.vue?vue&type=template&id=c9b6f73a"
import script from "./TrainingReflection.vue?vue&type=script&lang=js"
export * from "./TrainingReflection.vue?vue&type=script&lang=js"

import "./TrainingReflection.vue?vue&type=style&index=0&id=c9b6f73a&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__